<template>
    <div :class="`min-h-screen w-full bg-resource text-text pt-6 px-14 pb-14`">
        <div class="xl:w-2/3">
            <div class="px-6">
                <div class="mt-14 pb-6 space-y-16">
                    <ImageCarousel
                        v-if="mediaIds.length > 0"
                        :mediaIds="mediaIds"
                        modelClass="resource"
                        :useAccentBg="true"
                    />
                    <div class="flex justify-between items-center">
                        <p
                            class="text-8xl text-resource-accent font-header"
                            v-text="title"
                        />

                        <ButtonPopoverMenu
                            v-if="can?.update || can?.delete"
                            :items="menuItems"
                        >
                            <template #button="{ open }">
                                <div
                                    :class="[
                                        open
                                            ? `border-resource-accent bg-resource-accent text-resource`
                                            : 'border-transparent',
                                        `border hover:border-resource-accent h-14 w-14 p-2 rounded-full transition duration-button-hover focus-style`,
                                    ]"
                                >
                                    <PhDotsThreeOutline
                                        :class="['flex-grow']"
                                        weight="fill"
                                    />
                                </div>
                            </template>
                        </ButtonPopoverMenu>
                    </div>
                    <div class="user-written-body" v-html="description" />
                </div>
            </div>
        </div>
    </div>
    <ConfirmDangerModal ref="confirmDanger" />
</template>

<script>
import { defineAsyncComponent } from 'vue'
import ButtonPopoverMenu from '@/Components/Utilities/ButtonPopoverMenu.vue'
import ConfirmDangerModal from '@/Components/Modals/ConfirmDangerModal.vue'
import { PhDotsThreeOutline } from '@phosphor-icons/vue'
export default {
    components: {
        ImageCarousel: defineAsyncComponent(() =>
            import('@/Components/Elements/ImageCarousel.vue')
        ),
        ButtonPopoverMenu,
        PhDotsThreeOutline,
        ConfirmDangerModal,
    },

    props: {
        mediaIds: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        modelId: {
            type: Number,
            required: true,
        },
        can: {
            type: Object,
            required: true,
        },
    },

    computed: {
        menuItems() {
            let menuItems = []
            if (this.can?.update) {
                menuItems.push({
                    text: this.$lang.get('Edit'),
                    href: this.$localizedRoute('resource.edit', this.modelId),
                    type: 'link',
                })
            }
            if (this.can?.delete) {
                menuItems.push({
                    text: this.$lang.get('Delete'),
                    type: 'button',
                    action: () => {
                        this.deleteModel()
                    },
                })
            }

            return menuItems
        },
    },

    methods: {
        deleteModel() {
            this.$refs.confirmDanger
                .confirm({
                    title: this.$lang.get('Delete :definitive_item_name', {
                        definitive_item_name: this.$getBaseModelTranslation({
                            modelName: 'resource',
                            wordClass: 'DEFINITIVE',
                        }),
                    }),
                    body: this.$lang.get(
                        'Are you sure you want to delete :definitive_item_name?',
                        {
                            definitive_item_name: this.$getBaseModelTranslation(
                                {
                                    modelName: 'resource',
                                    wordClass: 'DEFINITIVE',
                                }
                            ),
                        }
                    ),
                })
                .then((confirmed) => {
                    if (confirmed) {
                        router.delete(
                            this.$localizedRoute(
                                'resource.destroy',
                                this.modelId
                            )
                        )
                    }
                })
        },
    },
}
</script>
